import React, {
  useRef,
  useState
} from 'react';
import { useSnackbar } from 'notistack';
import {
  Avatar,
  Box,
  ButtonBase,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import useAuth from 'src/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, ChevronUp, LogOut } from 'lucide-react';

const useStyles = makeStyles()((theme) => ({
  avatar: {
    height: 32,
    width: 32
  },
  popover: {
    width: 200,
    background: `${theme.palette.background.default} !important`
  },
  menuItem: {
    padding: theme.spacing(2)
  },
  list: {
    padding: theme.spacing(0)
  },
  accountOpen: {
    padding: 10,
    ':hover': {
      backgroundColor: 'var(--neutral-3)'
    }
  },
  metalPopover: {
    marginTop: 0,
    width: 210,
    backgroundColor: "var(--neutral-2)",
    paddingTop: 0,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0
  },
  metalMenuItem: {
    padding: theme.spacing(1),
    '&.Mui-disabled': {
      opacity: 1
    }
  },
  metalAccountOpen: {
    padding: 10,
    backgroundColor: "var(--neutral-2)", 
    borderTopRightRadius: "4px",
    borderTopLeftRadius: "4px",
    boxShadow: "0 0 1px 0 rgba(0,0,0,0.70), 0 5px 8px -2px rgba(0,0,0,0.50);"
  }
}));

const Account = () => {
  const { t }  = useTranslation();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const ref = useRef(null);
  const { user, logout, loggedInUser } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false); 
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('lg'));

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {

      //clearing the selected drop down values from session storage
      sessionStorage.clear()

      handleClose();
      await logout();
      navigate('/');
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('unableToLogout'), {
        variant: 'error'
      });
    }
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
        disableRipple={true}
        className={isOpen ? classes.metalAccountOpen : classes.accountOpen}
      >
        <Avatar
          alt="User"
          className={classes.avatar}
          src={user.avatar}
          style={ !mobileDevice ? {marginRight: theme.spacing(1)} :  {marginRight: theme.spacing(0.5) }}
        />
        {
          !mobileDevice && <Typography
          variant="h6"
          color="textPrimary"
          >
            {loggedInUser.fullName}
          </Typography>
        }
        {isOpen ? <ChevronUp size={24} color='#E9EBEA' style={!mobileDevice ? { marginLeft: theme.spacing(1)} : { marginLeft: theme.spacing(0.5)} } /> 
        : <ChevronDown size={24} color='#E9EBEA' style={!mobileDevice ? { marginLeft: theme.spacing(1)} : { marginLeft: theme.spacing(0.5)} } /> }
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        keepMounted
        PaperProps={{ className: classes.metalPopover }}
        anchorEl={ref.current}
        open={isOpen}
        classes={{list:classes.list}}
      >
        <MenuItem className={classes.metalMenuItem} onClick={handleLogout}>
          <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <LogOut size={18} style={{marginRight: theme.spacing(2)}}/>
            {t('logout')}
          </div>
        </MenuItem>
      </Menu>
    </>
  );
}

export default Account;
